import moment from 'moment';
export default {
  fromDbDate: function fromDbDate(da, str) {
    if (da && da !== '') {
      if (da === '30/11/-0001') {
        return null;
      }
      if (da.indexOf('-') === -1) {
        da = moment(da, 'DD/MM/YYYY');
      } else {
        da = moment(da, 'YYYY-MM-DD');
      }
      if (str) {
        return da.format('DD/MM/YYYY');
      }
      return da.toDate();
    }
    return null;
  },
  fromNow: function fromNow(str) {
    return moment(str, 'DD/MM/YYYY hh:mm:ss').fromNow();
  },
  fromDbTime: function fromDbTime(str) {
    return moment(str);
  },
  dateNow: function dateNow() {
    return moment().format('DD/MM/YYYY');
  }
};